// Adjunta la sesión (Authorization: Bearer) a toda llamada a la API propia (/api/...), salvo el
// login. El servidor exige sesión en /api/*; así ninguna pantalla tiene que acordarse de mandarla.
// Si el servidor responde 401 (sesión vencida o inválida), se cierra la sesión y se vuelve al login.
const originalFetch = window.fetch.bind(window)

function apiPath(input) {
  const url = typeof input === 'string' ? input : input instanceof Request ? input.url : String(input)
  try {
    const u = new URL(url, window.location.origin)
    return u.origin === window.location.origin && u.pathname.startsWith('/api/') ? u.pathname : null
  } catch {
    return null
  }
}

window.fetch = async (input, init = {}) => {
  const path = apiPath(input)
  if (!path || path.startsWith('/api/auth/')) return originalFetch(input, init)

  let token = ''
  try { token = JSON.parse(localStorage.getItem('gm_session') || '{}').token || '' } catch { /* sesión ilegible */ }
  const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined))
  if (token && !headers.has('Authorization')) headers.set('Authorization', 'Bearer ' + token)

  const res = await originalFetch(input, { ...init, headers })
  if (res.status === 401) {
    try { localStorage.removeItem('gm_session') } catch { /* nada que limpiar */ }
    window.location.reload()
  }
  return res
}
